/**
 * @file 扩展Element的错误提示message组件(多行内容)
 */

import { message } from 'ant-design-vue'

interface Option {
    duration?: number
    type?: string
}

export default function toast(
    msg: string,
    option: Option | string = { duration: 3, type: 'warning' } || 'warning'
) {
    let type =
        typeof option === 'string'
            ? option || 'warning'
            : option.type || 'warning'
    let duration = typeof option === 'string' ? 3 : option.duration || 3
    message.config({
        top: `100px`,
        duration: duration,
        maxCount: 3,
    })
    switch (type) {
        case 'success':
            message.success(msg)
            break
        case 'warning':
            message.warning(msg)
            break
        case 'error':
            message.error(msg)
            break
        case 'info':
            message.info(msg)
            break
        default:
            break
    }
}
